<template>
  <div data-test="content-renderer">
    <component
      :is="getComponentType(block.type)"
      v-for="(block, index) in content"
      :key="index"
      :block
    />
  </div>
</template>

<script setup lang="ts">
import type { ContentBlock } from '@backmarket/catalog-shared-artifacts'

import ListBlock from './components/ListBlock.vue'
import TableBlock from './components/TableBlock.vue'
import TextBlock from './components/TextBlock.vue'

defineProps<{
  content: ContentBlock[]
}>()

const getComponentType = (type: string) => {
  switch (type) {
    case 'text':
      return TextBlock
    case 'list':
      return ListBlock
    case 'table':
      return TableBlock
    default:
      return 'div'
  }
}
</script>
